import RegisterForm from "src/components/pages/Auth/Register/RegisterForm";

const Register = () => {
  return <RegisterForm />;
};

export default Register;
